import React, { act, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";
import Table from "../../core/common/dataTable/index";
import { apibaseurl } from "../../environment";
import Loader from "../../core/common/selfLoder";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";


interface Compensation {
    employee_id: string;
    employee_name: string;
    join_date: string;
    year: string;
    annual_ctc: string;
    annual_fixed: string;
    annual_variable: string;
    modified_by: string | null;
    modified_date: string | null;
    created_date: string | null;
    variablePercent?: number; // Adding a possible field for variable percentage
}



interface CompensationResponse {
    success: boolean;
    statusCode: number;
    data: Compensation[];
}

const CompensationPage = () => {


    const {
        data: compensations,
        loading: isLoadingecompensations,
        error,
        callApi: postAdvanseexpentdata,
    } = useApi<CompensationResponse>("/api/employee/compensation", {
        method: "GET",
        autoCall: true,
    });

    const location = useLocation();
    const [data, setData] = useState<Compensation>({
        employee_id: "",
        employee_name: "",
        join_date: "",
        year: "",
        annual_ctc: "",
        annual_fixed: "",
        annual_variable: "",
        modified_by: "",
        modified_date: "",
        created_date: "",
    });

    const isCompensationActive = location.pathname === all_routes.compensationPage;
    const isAnnexureActive = location.pathname === all_routes.annexurePage;

    const filteredAdvanseData = compensations?.data?.map((item: Compensation, index: number) => ({
        ...item,
        Sno: index + 1,
        variablePercent: item.annual_variable ? (parseFloat(item.annual_variable) / parseFloat(item.annual_ctc)) * 100 : 0,
    }));

    const tableData = filteredAdvanseData || [];

    const getButtonStyle = (isActive: boolean) => ({
        backgroundColor: isActive ? "#2e3294" : "transparent",
        color: isActive ? "#ffffff" : "#2e3294",
        border: "1px solid #2e3294"
    });



    return (
        <>
            <Loader loading={isLoadingecompensations} />
            <div className="page-wrapper">
                <div className="content">
                    {/* BreadCrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Compensation</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Work & Operations</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Compensation
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-start flex-wrap row-gap-3">
                            <Link to={all_routes.compensationPage}>
                                <button
                                    className="btn px-2 mx-2 px-sm-4"
                                    style={getButtonStyle(isCompensationActive)}
                                >
                                    Compensation
                                </button>
                            </Link>
                            <Link to={all_routes.annexurePage}>
                                <button
                                    className="btn px-2 px-sm-4"
                                    style={getButtonStyle(isAnnexureActive)}
                                >
                                    Annexure
                                </button>
                            </Link>
                        </div>

                        <div className="card-body">
                            <div className="card">
                                <Table
                                    dataSource={tableData}
                                    columns={[
                                        { title: "S.No", dataIndex: "Sno" },
                                        { title: "Employee Name", dataIndex: "employee_name" },
                                        { title: "Date of Joining", dataIndex: "join_date" },
                                        { title: "Compensation Year", dataIndex: "year" },
                                        { title: "Annual CTC", dataIndex: "annual_ctc" },
                                        { title: "Annual Fixed", dataIndex: "annual_fixed" },
                                        { title: "Annual Variable", dataIndex: "annual_variable" },
                                        { title: "Variable %", dataIndex: "variablePercent", render: (value: any) => `${value.toFixed(0)}%` },
                                    ]}
                                    Selection={false}
                                    showSearchInput={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default CompensationPage;